import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterAuthForm.styl';


Vue.component('BXmakerAuthuserphoneEnterAuthForm', {
    name: 'BXmakerAuthuserphoneEnterAuthForm',
    data() {
        return {};
    },
    computed: {

    },
    methods: {
        onEnterPhone() {
            this.onClickConfirm();
        },
        onCompleteCaptcha() {
            this.onClickConfirm();
        },
        onClickConfirm() {
            if (this.$root.isFullCaptcha) {
                this.$root.authByPhone();
            }
        },
        onClickAuthByPass() {
            this.$root.setIsAuthByPassword(true);
        },
        onChangePhone(data){
            this.$root.setPhone(data.formattedValue);
        }
    },
    template: `
            <div class="bxmaker-authuserphone-enter-auth-form"  >
                 
                 <slot name="message" />  
                        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />
                 </slot>     
                                                
                 <slot name="phone"> 
                       <BXmakerAuthuserphoneInputPhone  v-if="$root.isEnabledPhoneMask"
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_PHONE" 
                           :value="$root.phone" 
                            @onChange="onChangePhone" 
                            @onEnter="onEnterPhone" 
                            name="PHONE" 
                            :defaultCountry="$root.phoneMaskDefaultCountry"
                            :countryTopList="$root.phoneMaskCountryTopList"                          
                        /> 
                        <BXmakerAuthuserphoneInput v-else
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_PHONE" 
                            :value="$root.phone" 
                            @onInput="$root.setPhone" 
                            @onEnter="onEnterPhone" 
                            name="PHONE"
                        />
                 </slot>
                                                
                                                
                <slot name="captcha">
                     <BXmakerAuthuserphoneCaptcha 
                         :code="$root.captchaCode"
                         :src="$root.captchaSrc"
                         :length="$root.captchaLength"
                         :loader="$root.captchaLoader"
                         @onInput="$root.setCaptchaCode"
                         @onComplete="onCompleteCaptcha"
                         @onRefresh="$root.refreshCaptcha"
                        />  
                </slot>   
                                         
                <slot name="request">
                   <BXmakerAuthuserphoneButton 
                       :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_BUTTON"  
                       :loader="$root.startLoader"
                       @onClick="onClickConfirm" 
                   />                   
                </slot>
                
                <slot name="bypass">
                     <div class="bxmaker-authuserphone-enter-auth-form__bypass">
                        <BXmakerAuthuserphoneLink @onClick="onClickAuthByPass" >
                        {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_BY_PASS}}   
                       </BXmakerAuthuserphoneLink> 
                    </div>                    
                </slot>     
                             
            </div>
        `,
});